import React from 'react'
import styled from 'styled-components'
import { ReactComponent as InfoSvg } from '../../assets/svg/info.svg'
import { TransitionsAnim } from 'animations/Transitions'
interface Props {
  fadeOut: boolean
  background: string
  textColor: string
}
const { popUpSlideDown, popUpSlideUp } = TransitionsAnim()
export const NotificationContainer = styled.div<Props>`
  ${popUpSlideDown};
  ${p => (p.fadeOut ? popUpSlideUp : null)};
  position: absolute;
  top: 30px;
  display: flex;
  align-items: center;
  width: 100%;
  background: ${({ background }) => background};
  color: ${({ textColor }) => textColor};
  border-radius: 10px;
  padding: 18px;
  /* max-width: 260px;
  max-width: 120px; */
  max-width: 315px;
  right: 50%;
  font-size: 12px;
  transform: translateX(50%) translateY(-100px);
  z-index: 4;
  pointer-events: auto;
  p {
    width: 80%;
    padding: 20px;
  }
  & > svg {
    position: absolute;
    top: 12px;
    right: 12px;
    cursor: pointer;
    stroke: ${({ textColor }) => textColor};
  }
`
export const NotificationIcon = styled.div<{ background: string }>`
  position: relative;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: ${({ background }) => background};
  display: flex;
  align-items: center;
  justify-content: center;
`

// export const NotificationFrame = styled.div`
//   position: absolute;
//   height: 100%;
//   top: 0;
//   left: 0;
//   right: 0;
//   display: flex;
//   justify-content: center;
//   align-items: center;
// `
// export const Scaling = styled.div`
//   position: relative;
//   height: 607px;
//   min-height: 607px;
//   width: 315px;
// `
export const Icon = ({ background }: any) => {
  return (
    <NotificationIcon background={background}>
      <InfoSvg />
    </NotificationIcon>
  )
}
